export default {
  login: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
  },
};
